export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./blog.vue?vue&type=template&id=4db8f936&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/blog.vue?vue&type=template&id=4db8f936&
// module id = 78
// module chunks = 0